import React from 'react';

const Required = (props) => <span className='text-danger'>*</span>;

export default Required;
